import React from 'react';
import SideBar from '../components/sidebar/SideBar';
import NavBar from '../components/NavBar';

const DashboardLayout = ({children}) => {
  return (
    <div className='flex'>
      <SideBar />
      <div className="w-full">
        <NavBar />
        <div>
          { children } 
        </div>
      </div>
    </div>
  )
}

export default DashboardLayout